import { render, staticRenderFns } from "./LoadMoreBtn.vue?vue&type=template&id=cb3445b6&scoped=true"
import script from "./LoadMoreBtn.vue?vue&type=script&lang=js"
export * from "./LoadMoreBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3445b6",
  null
  
)

export default component.exports